import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function EditAccount({ showEdit, closeModal, refreshPage, currentAccount }) {
    const [formData, setFormData] = useState({
        account_name: "",
        account_number:"",
        bank: "",
    });

    useEffect(() => {
        if (currentAccount) {
            setFormData({
                account_name: currentAccount.account_name || "",
                account_number: currentAccount.account_number || "",
                bank: currentAccount.bank || "inactive",
            });
        }
    }, [currentAccount]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await axiosInstance.post(`/user/bank_account/update/${currentAccount.id}`, formData);
            toast.success("Account updated successfully!");
            closeModal();
            refreshPage();
        } catch (error) {
            console.error("Error updating account:", error);
            toast.error("Failed to update account. Please try again.");
        }
    };

    return (
        <Modal show={showEdit} onHide={closeModal} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Account</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="accountName" className="mb-3">
                        <Form.Label>Account Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter account name"
                            name="account_name"
                            value={formData.account_name}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                    <br />
                    <Form.Group controlId="accountName" className="mb-3">
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter account name"
                            name="account_number"
                            value={formData.account_number}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                    <br />
                    <Form.Group controlId="accountName" className="mb-3">
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter account name"
                            name="bank"
                            value={formData.bank}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={closeModal} className="me-2">
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                            Save Changes
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
